import React from "react";

type CheckboxOptionProps = {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const CheckboxOption = ({
  id,
  label,
  checked,
  onChange
}: CheckboxOptionProps) => {
  return (
    <div className="PreviewBookingModalBeta__option flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="PreviewBookingModalBeta__checkbox"
      />
      <label
        htmlFor={id}
        className="text-sm text-[var(--primaryColor)] cursor-pointer select-none"
      >
        {label}
      </label>
    </div>
  );
};
